var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Transform } from 'class-transformer';
export class AlertOutputFormatColumnModel {
    fieldName;
    regex = '';
    sort;
    // This is helping us workaround the fact that we don't really get an ID
    id;
}
__decorate([
    Expose({ toClassOnly: true })
    // Set the fieldName as the ID to help us keep track of changes to the column
    ,
    Transform((_, column) => column.fieldName, { toClassOnly: true }),
    __metadata("design:type", Object)
], AlertOutputFormatColumnModel.prototype, "id", void 0);
//# sourceMappingURL=alert-output-format-column.js.map